export const MoreOptionsIcon = () => {
    return (
        <svg
            width={20}
            height={4}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="fill-black dark:fill-white"
        >
            <path d="M2 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM10 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM18 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
        </svg>
    );
};
